import React, { StrictMode } from 'react';
import { render } from 'react-dom';
import App from 'App';
import 'Styles/index.scss';

render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.querySelector('#root')
);
